export default __webpack_public_path__ + "static/media/slide9.2a0368f0.jpg";